import { call, put, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { 
  placeOrderRequest, 
  placeOrderSuccess, 
  placeOrderFailure, 
  fetchPaymentStatusRequest,
  fetchPaymentStatusSuccess,
  fetchPaymentStatusFailure,
  OrderRequest, 
  OrderResponse,
  PaymentStatusRequest,
  PaymentStatusResponse
} from '../slices/orderSlice';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import { shouldSkipApiCalls } from '../../utils/appConfig';

function* placeOrderSaga(action: PayloadAction<OrderRequest>) {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    const response: { data: OrderResponse } = yield call(request, {
      method: 'POST',
      url: ENDPOINTS.PLACE_ORDER_API_PATH,
      data: action.payload,
    });
    
    yield put(placeOrderSuccess(response.data));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to place order';
    yield put(placeOrderFailure(errorMessage));
  }
}

function* fetchPaymentStatusSaga(action: PayloadAction<PaymentStatusRequest>) {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    const response: { data: PaymentStatusResponse } = yield call(request, {
      method: 'GET',
      url: `${ENDPOINTS.PAYMENT_STATUS_API_PATH}?order_id=${action.payload.order_id}`,
    });
    
    yield put(fetchPaymentStatusSuccess(response.data));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch payment status';
    yield put(fetchPaymentStatusFailure(errorMessage));
  }
}

export function* watchOrderSaga() {
  yield takeEvery(placeOrderRequest.type, placeOrderSaga);
  yield takeEvery(fetchPaymentStatusRequest.type, fetchPaymentStatusSaga);
}
